// app/src/components/aivaCard.js — Card padrao de respostas da AIVA (feature SDD 010).
// Componente unico reusado em todas as superficies de IA do app. Substitui o selo
// o selo antigo de IA pela assinatura "by AIVA" e da voz/personalidade as respostas.
import './aivaCard.css';
import { esc } from '../lib/dom.js';
import { aivaFace } from './aivaFace.js';
export { aivaFace, aivaExpressao } from './aivaFace.js';

// O PNG saiu: agora é SVG, com expressão. Estados: neutra · atenta · pensando ·
// falando · feliz · preocupada · erro · dormindo (Basic).
export function aivaMark(size = 30, expressao = 'neutra') {
  return aivaFace(size, expressao);
}
// Estados REAIS da AIVA. Falha ≠ plano: um cliente PRO que bate no limite diário não pode
// ver "BASIC" (parece que perdeu o que pagou). Ele continua PRO — a IA é que está indisponível.
export function aivaSign(estado = 'pro') {
  if (estado === 'basic') return '<span class="aiva-sign basic">BASIC</span>';
  if (estado === 'loading') return '<span class="aiva-sign">by AIVA \u00b7 analisando\u2026</span>';
  if (estado === 'cache') return '<span class="aiva-sign">by AIVA \u00b7 cache</span>';
  if (estado === 'limite') return '<span class="aiva-sign">by AIVA \u00b7 PRO \u00b7 limite di\u00e1rio</span>';
  if (estado === 'cota') return '<span class="aiva-sign">by AIVA \u00b7 PRO \u00b7 cota do m\u00eas</span>';
  if (estado === 'erro') return '<span class="aiva-sign">by AIVA \u00b7 PRO \u00b7 indispon\u00edvel</span>';
  return `<span class="aiva-sign">by AIVA${estado === 'pro' ? ' \u00b7 PRO' : ''}</span>`;
}

// Traduz o erro da Edge Function no estado certo (e na frase honesta).
export function aivaEstadoErro(err) {
  const code = err?.code || err?.error || '';
  const body = err?.body || err || {};
  if (code === 'rate_limit' || body.error === 'rate_limit') {
    return { estado: 'limite', expressao: 'dormindo',
      msg: `Você usou as <b>${body.limit || 50} análises</b> de hoje. Elas voltam em 24h — nada foi perdido.` };
  }
  if (code === 'cota_mensal_ia' || body.error === 'cota_mensal_ia') {
    return { estado: 'cota', expressao: 'dormindo',
      msg: body.message || 'A cota mensal de IA da empresa foi atingida — ela renova no dia 1º.' };
  }
  if (err?.status === 429) {   // 429 sem código explícito ainda é limite, não instabilidade
    return { estado: 'limite', expressao: 'dormindo',
      msg: 'Você usou as <b>análises de hoje</b>. Elas voltam em 24h — nada foi perdido.' };
  }
  if (err?.status === 402 || code === 'plano') {
    return { estado: 'basic', expressao: 'dormindo', msg: null };  // aí sim é plano
  }
  return { estado: 'erro', expressao: 'erro',
    msg: 'Não consegui analisar agora. Tento de novo em alguns minutos — nada foi perdido.' };
}
const _EXP = { pro: 'neutra', clean: 'neutra', loading: 'pensando', cache: 'neutra', basic: 'dormindo' };

// Voz: a AIVA e solicita e proativa, mas VARIA — nunca um bordao fixo. Helper de rodizio leve
// para copias estaticas (recebe um array de variantes e devolve uma).
export function aivaVar(variantes) {
  if (!Array.isArray(variantes) || !variantes.length) return '';
  return variantes[Math.floor(Math.random() * variantes.length)];
}

// opts: { contexto, corpoHTML, acoes:[{label, nav?, onClick?, icon?, primary?}], estado:'pro'|'basic'|'clean' }
export function aivaCard(opts = {}) {
  const { contexto = '', corpoHTML = '', acoes = [], estado = 'pro' } = opts;
  const sign = aivaSign(estado);
  const actionsHTML = (acoes || []).map((a) => {
    const cls = a.primary ? 'aiva-btn primary' : 'aiva-btn ghost';
    const handler = a.nav ? `data-nav="${esc(a.nav)}"` : (a.onClick ? `onclick="${a.onClick}"` : (a.attr || ''));
    const ic = a.icon ? `${a.icon} ` : '';
    return `<button class="${cls}" ${handler}>${ic}${esc(a.label)}</button>`;
  }).join('');
  return `
    <div class="aiva-card ${estado}">
      <div class="aiva-card-head">
        <div class="aiva-id">${aivaMark(44, opts.expressao || _EXP[estado] || 'neutra')}<div><div class="nm">AIVA</div>${contexto ? `<div class="ctx">${esc(contexto)}</div>` : ''}</div></div>
        ${sign}
      </div>
      <div class="aiva-card-msg">${corpoHTML}</div>
      ${actionsHTML ? `<div class="aiva-card-actions">${actionsHTML}</div>` : ''}
    </div>`;
}
